<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- Carga el compononte para activar modal de  ver calendario -->
    <component :is="componenteCalendario" :modalCalen="estadoModalCalen" @close="estadoModalCalen = false"></component>
    <!-- <Calendario></Calendario> -->

    <!-- MODAL calendario para crear activiadades-->
    <component :is="compNombre2" :compEstado2="compEstado2" :compParametro2="compParametro2" @close="compEstado2 = false">
    </component>

    <!-- MODAL  para visualizar actividades cargadas por el docente-->
    <component :is="tipoComponente" :modalActividad="estadoModal" @close="estadoModal = false"
      :datosClase="itemClaseSeccion" :eventoActividad="valorEvento">
    </component>

    <!-- Componente de Asistencia de clase programada -->
    <component :is="componenteAsistencia" :modalAsistencia="estadoModalAsistencia" @close="estadoModalAsistencia = false"
      :datosProgDocente="parametroAsistencia">
    </component>

    <!--Componente de participacion de la clase -->
    <component :is="componenteParticipacion" :modalParticipacion="estado_modal_participacion"
      @close="cerrarParticipacionClase" :datosClase="parametroParticipacionClase"></component>

    <!-- MODAL SELECCIONAR CLASE ck1 o colegio  -->
    <component :is="componenteSelecClase" :estadoComp="estadoModalSelecClase" @close="estadoModalSelecClase = false"
      :datosSelecClase="parametroSelecClase" @visor="visualizarClase"
      :actualizarConsulta="estadoConsulta" @cargarmain="cargarMain">
    </component>

    <!-- MODAL WIZARD-CLASE -->
    <component :is="compNombre" :compEstado="compEstado" :compParametro="compParametro" @close="compEstado = false"
      @cargarmain="cargarMain">
    </component>

    <component :is="compName" :estadoModal="estadoModalConfig" @mostrarParticipacion="abrirParticipacionClase"
      @close="estadoModalConfig = false" :parametros="parametroConfigVisor" :mostrarBotonParticipacion="true">
    </component>

    <component :is="compName2" :estadoComp="estadoComponente" :parametros="parametroComp"
      @close="estadoComponente = false">
    </component>

    <!-- COMPONENTE VISOR DE CONTENIDOS-->
    <component :is="compNameVisorSH" :estadoComp="estadoComponenteVisorSH" :parametros="parametroCompVisorSH"
      @close="estadoComponenteVisorSH = false">
    </component>

    <!-- MODAL VISOR DE CONTENIDOS-->
    <v-dialog v-model="visor" scrollable max-width="80%">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row class="d-flex justify-space-between py-0">
            Contenido
            <v-btn fab dark x-small class="btn_style3" @click="cerrarVisor"><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center">
          <component :is="tipoVisor" :diapositivas="api_list_contenidos"></component>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- boton crear -->
    <v-alert outlined color="primary">
      <v-row class="d-flex justify-space-between">
        <v-col cols="12" sm="6" md="2" xs="12" class="pl-1">
          <v-btn color="primary" v-if="componenteEvento.agregar_submodulo" @click="asociarClase" plain><v-icon left> fas
              fa-tasks </v-icon> PROGRAMAR CLASE
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="2" xs="12" class="pl-1">
          <v-btn plain color="primary" v-if="componenteEvento.agregar_submodulo" to="/gestionContenidoColegio">
            <v-icon left dark>fas fa-box-open</v-icon> gestión de
            contenidos</v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="2" xs="12" class="pl-1">
          <v-btn plain color="primary" v-if="componenteEvento.visualizar_submodulo" @click="verCalendario">
            <v-icon left>fas fa-calendar-alt</v-icon> VER CALENDARIO</v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="2" xs="12" class="pl-1">
          <v-btn plain color="primary" v-if="componenteEvento.visualizar_submodulo" @click="verActividades">
            <v-icon left> fas fa-book </v-icon> ACTIVIDADES</v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="2" xs="12" class="pl-1">
          <v-btn plain color="primary" v-if="componenteEvento.visualizar_submodulo" @click="generarExcel">
            <v-icon left> fas fa-calendar-alt </v-icon>HORARIO</v-btn>
          </v-col>
      </v-row>


    </v-alert>

    <v-row dense>
      <v-col cols="12" sm="4" md="2">
        <AutocompleteComp textLabel="Nivel" v-model="filtroProgDoc.id_nivel" :items="nivelDoc" item-value="id_nivel"
          item-text="desc_nivel" @change="eventNivelDoc" />
      </v-col>

      <v-col cols="12" sm="4" md="2">
        <AutocompleteComp textLabel="Grado" v-model="filtroProgDoc.id_grado" :items="gradoDocFilter"
          :isDisable="inhabilitarGradoDoc" item-value="id_grado" item-text="desc_grado" @change="eventGradoDoc" />
      </v-col>

      <v-col cols="12" sm="4" md="3">
        <AutocompleteComp textLabel="Área" v-model="filtroProgDoc.id_area" :items="areaDocFilter"
          :isDisable="inhabilitarAreaDoc" item-value="id_area" item-text="desc_area" @change="eventAreaDoc" />
      </v-col>

      <v-col cols="12" sm="4" md="3">
        <AutocompleteComp textLabel="Curso" v-model="filtroProgDoc.id_curso" :items="cursoDocFilter"
          :isDisable="inhabilitarCursoDoc" item-value="id_curso" item-text="desc_curso" @change="eventCursoDoc" />
      </v-col>

      <v-col cols="1" class="d-flex justify-end align-center">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" icon color="blue" @click="resetearFiltros()">
              <v-icon>fas fa-sync-alt</v-icon>
            </v-btn>
          </template>
          <span>Restablecer filtros </span>
        </v-tooltip>
      </v-col>
      <v-col cols="1" class="d-flex align-center">
        <ButtonComp iconBut="fas fa-filter" textButton="Filtros" @click="datefiltros = !datefiltros" />
      </v-col>
      <v-col cols="12" v-if="datefiltros" class="d-flex justify-center">
        <v-card outlined>
          <v-card-title dense>
            <v-row dense>
              <v-col class="text-center subtitle-2">
                Filtros de busqueda
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col cols="12" sm="3" md="4">
                <v-menu v-model="menuStartData" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="start_date" label="Fecha inicial" prepend-icon="far fa-calendar-times" readonly
                      v-bind="attrs" v-on="on" clearable @click:clear="limpiarFecha('inicio')"></v-text-field>
                  </template>
                  <v-date-picker v-model="start_date" :allowed-dates="allowedDays" @input="
                    menuStartData = false;
                  loadMain();
                  "></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3" md="4">
                <v-menu v-model="menuEndData" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="end_date" label="Fecha final" prepend-icon="far fa-calendar-times" readonly
                      v-bind="attrs" v-on="on" clearable @click:clear="limpiarFecha('fin')">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="end_date" :allowed-dates="allowedDays" @input="
                    menuEndData = false;
                  loadMain();
                  "></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <ComundataTablecomp :headers="ProgramacionDocenteHeader" :items="progDocente" :search="search" whitSearch>
          <template v-slot:nombre_tema="{ item }">

            <v-tooltip bottom color="#1b1b1b">
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                > {{ item.nombre_tema }}</span>
              </template>
              <span> Area: {{ item.desc_area }}</span>
            </v-tooltip>

          </template>
          <template v-slot:hora_inicio="{ item }">
            {{ formatearHora(item.hora_inicio) }}
          </template>
          <template v-slot:hora_fin="{ item }">
            {{ formatearHora(item.hora_fin) }}
          </template>
          <template v-slot:fecha="{ item }">
            {{ formatearFecha(item.fecha) }}
          </template>
          <template v-slot:desc_estado="{ item }">
            <v-chip small dark class="font-weight-black" :color="item.color_estado">
              {{ item.desc_estado }}
            </v-chip>
          </template>

          <template v-slot:acc_prog="{ item }">
            <div class="d-flex justify-center">
              <v-menu :close-on-content-click="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
                    <v-icon> fa-ellipsis-v </v-icon>
                  </v-btn>
                </template>
                <!-- <v-card class="mx-auto" max-width="250">
                  <v-card-text> -->
                    <v-list mandatory dense>
                      <v-list-item class="d-flex justify-center">
                        <v-chip label small> Visualización </v-chip>
                      </v-list-item>
                      <v-divider />
                      <v-list-item-group>
                        <v-list-item v-if="componenteEvento.visualizar_submodulo" @click="
                          visualizarClase(item.id_clase, item.tipo_contenido)
                          ">
                          <v-list-item-icon class="ma-2">
                            <v-icon color="green" size="small">fa-eye</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Ver "clase"</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="componenteEvento.visualizar_submodulo" @click="
                          visualizarSomosHabilesProgDoc(
                            item.id_clase,
                            item.id_colegio,
                            item.tipo_contenido,
                            item
                          )
                          " :disabled="item.desc_estado != 'Ejecutada' ? true : false">
                          <v-list-item-icon class="ma-2">
                            <v-icon color="brown" size="small">fa-book</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Ver "Somos hábiles"
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="componenteEvento.visualizar_submodulo &&
                          item.clase_virtual
                          " @click="
                            validarEnlace(
                              item.enlace_virtual,
                              item.fecha,
                              item.hora_inicio,
                              item.hora_fin,
                              item.id_estado
                            )
                            " :disabled="item.id_estado == 3 || item.id_estado == 4">
                          <v-list-item-icon class="ma-2">
                            <v-icon color="red" size="small">fa-video</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Ver "Clase virtual"</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="componenteEvento.visualizar_submodulo" @click="
                          GetSesionAprendizaje(
                            item,
                            item.id_sesion_aprendizaje
                          )
                          ">
                          <v-list-item-icon class="ma-2">
                            <v-icon color="primary" size="small">fa-eye</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Ver "Sesión de aprendizaje"</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item v-if="componenteEvento.visualizar_submodulo &&
                          item.clase_virtual_video == 1
                          " :href="item.clase_virtual_video_enlace" target="_blank">
                          <v-list-item-icon class="ma-2">
                            <v-icon color="green" size="small">fa-file-video</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Ver "Video de clase grabada"</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>

                      <v-list-item class="d-flex justify-center">
                          <v-chip label small> Edición </v-chip>
                        </v-list-item>
                        <v-divider />
                      <v-list-item-group v-model="editOptions">                    
                        <v-list-item v-if="componenteEvento.editar_submodulo"
                          :disabled="item.id_estado == 3 || item.id_estado == 4" @click="editItem(item)">
                          <v-list-item-icon class="ma-2">
                            <v-icon color="orange" size="small">fa-pencil-alt</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Editar</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <!-- <v-list-item v-if="componenteEvento.editar_submodulo" :disabled="item.id_estado != 1 ||
                          new Date(item.fec_us_ing)
                            .toISOString()
                            .substr(0, 10) !=
                          new Date().toISOString().substr(0, 10)
                          " @click="deleteConfirm(item)">
                          <v-list-item-icon class="ma-2">
                            <v-icon color="red" size="small">fa-trash-alt</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Eliminar</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item> -->
                      </v-list-item-group>
                    </v-list>
                  <!-- </v-card-text>
                </v-card> -->
              </v-menu>
            </div>
          </template>

          <template v-slot:asig_prog="{ item }">
            <!-- <pre>{{ item }}</pre> -->
            <ButtonComp v-if="componenteEvento.agregar_submodulo" :disabled="item.id_estado == 4"
              @click="asignarActividades(item)" classColor="primary" tooltip-text="Asignar actividad"
              iconBut="fas fa-book" />
          </template>
          <template v-slot:asist_prog="{ item }">
            <ButtonComp v-if="componenteEvento.agregar_submodulo" @click="asistenciaVirtual(item)"
              tooltip-text="Asistencia de clase" class-color="primary" iconBut="fas fa-users" />
          </template>
          <template v-slot:segui_prog="{ item }">
            <ButtonComp v-if="componenteEvento.visualizar_submodulo" @click="verSeguimiento(item.id)"
              tooltipText="Seguimiento de programación docente" listButton />
          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>

    <!--------   pantalla principal   ------>

    <!-- /////////////////////////////////////////////////////
          //         MODAL DE BORRAR REGISTROS                  //
          /////////////////////////////////////////////////////    -->
    <v-dialog v-model="dialog_delete" max-width="450px">
      <v-card>
        <v-card-title class="btn_ver">
          <v-spacer />
          <v-btn fab dark x-small class="btn_style3" @click="dialog_delete = false"><v-icon dark>fa-times</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-center">
          <h3>
            ¿Está seguro de eliminar este registro?
            <v-chip color="yellow font-weight-black">
              Tema: {{ nombre }}</v-chip>
            <br />
            <v-chip color="primary font-weight-black">
              Fecha: {{ fecha }}</v-chip><br />
            <div class="grid-col-2">
              <v-chip> Hora: {{ hora_inicio }}</v-chip>
              <v-chip> ID: {{ id_delete }}</v-chip>
            </div>
          </h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="dialog_delete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteItem">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrar registro -->

    <!-- ////////////////////////////////////////////////////
          //        MODAL DE SEGUIMIENTO O HISTORIAL        //
          ////////////////////////////////////////////////////    -->
    <v-dialog v-model="modal_seguimiento" persistent scrollable min-width="500px">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row>
            <v-col cols="10"> Seguimiento de la clase </v-col>
            <v-col cols="2" class="d-flex justify-end">
              <v-btn fab dark x-small class="btn_style3" @click="modal_seguimiento = false"><v-icon
                  dark>fa-times</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text>
          <v-timeline dense>
            <v-slide-x-reverse-transition group hide-on-leave>
              <v-timeline-item v-for="(item, i) in seguimientoClase" :key="i" :color="item.color_estado" small>
                <template v-slot:opposite>
                  <span class="title font-weight-bold">
                    {{ item.fec_us_ing.substr(0, 10) }}
                    {{ item.fec_us_ing.substr(11, 8) | filtroFormatoHora }}
                  </span>
                </template>

                <v-card class="elevation-2" width="450">
                  <v-card-title class="headline">
                    <v-row>
                      <v-col cols="12" md="6" class="py-1">
                        <v-chip dark class="font-weight-black" :color="item.color_estado">
                          <h2>{{ item.desc_estado }}</h2>
                        </v-chip>
                      </v-col>
                      <v-col cols="12" md="6" class="py-1">
                        <v-chip>
                          {{ item.fec_us_ing.substr(0, 10) }}
                          {{
                            item.fec_us_ing.substr(11, 8) | filtroFormatoHora
                          }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text>
                    <label class="body-1">
                      <span class="black--text">Fecha:</span> {{ item.fecha }}
                    </label>
                    <br />
                    <label class="body-1">
                      <span class="black--text">Hora:</span>
                      {{ item.hora_inicio | filtroFormatoHora }} -
                      {{ item.hora_fin | filtroFormatoHora }}
                    </label>
                    <br />
                    <label class="body-1">
                      <span class="black--text">Clase virtual:</span>
                      {{ item.clase_virtual_desc }}
                    </label>
                    <br />
                    <label class="body-1">
                      <span class="black--text">Observación:</span>
                      {{ item.observacion }}
                    </label>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-slide-x-reverse-transition>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- fin modal de Seguimiento -->

    <!-- fin modal de participacion de la clas-->

    <!--modal para sesion de aprendizaje -->
    <!-- <v-dialog v-model="modalSesion" persistent scrollable max-width="90%">
      <SesionAprendizaje @close="modalSesion = false" :compEstadoP="modalSesion" :compParametroP="parametroSA">
      </SesionAprendizaje>
    </v-dialog> -->
    <!-- fin modal de sesion de aprendizaje -->

    <!-- SOMOS HABILES RESULTADOS -->
    <ComunDialogComp v-model="verSomosHabilesPogDoc" :title="`Resultados - Somos hábiles del area de '' ${datosClaseActive.desc_area}''`"
      @close-modal="CloseverSomosHabilesPogDoc()" maxWidth="1200">
      <template v-slot:body>
        <v-stepper :hide-stepper-header="true" v-model="e1">

          <v-stepper-items>
            <v-stepper-content step="1">
              
              <v-row>

                <v-col v-if="btnReasigar" cols="12">
                  <v-btn @click="reasignarSomosHabiles(idprog_doc)" small color="success" dark>                    
                    <v-icon left> mdi-account-multiple-outline </v-icon>
                      Reasignar Somos hábiles
                  </v-btn>
                </v-col>

                <v-col cols="12">
                   
                  <span class="grey--text text-truncate hidden-sm-and-down">{{ `* Lista de examenes (somos hábiles) de los estudiantes de la clase '${datosClaseActive.nombre_clase}'` }}</span>
                  
                  <v-sheet color="transparent" class="" v-if="readyloadLista">
                    <v-skeleton-loader class="mx-auto"
                      type="table-thead, table-row-divider@2, table-tfoot"></v-skeleton-loader>
                  </v-sheet>
                  <v-simple-table v-else fixed-header>
                    <thead>
                      <tr>
                        <th v-for="titulo in cabecera" :key="titulo.valor" style="
                            background: #bdbdbd;
                            cursor: pointer;
                            font-size: 12px !important;
                          " :class="titulo.clase" @click="ordenPorColumnaDoc(titulo.valor_accion)">
                          <v-icon color="dark" size="20" v-if="titulosColumna[titulo.valor_accion] ||
                            titulo.exclusion
                            ">{{ titulo.icono }}</v-icon><v-icon v-else color="dark" size="20">
                            {{ titulo.icono_accion }} </v-icon>{{ titulo.valor }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <pre>{{ itemArrayMuestras[0].muestra.length - 1 }}</pre> -->
                      <!-- Si la tabla esta vacia un mensaje -->
                      <tr v-if="MensajeNoExisteData != null">
                        <td class="text-center" colspan="6">
                          {{ MensajeNoExisteData }}
                        </td>
                      </tr>                   

                      <!-- Si la tabla no esta vacia -->
                      <template v-else>
                        <tr v-for="(muestra, index) in itemArrayMuestras" :key="index">
                          <td class="shrink-column">

                            <v-tooltip color="#1b1b1b" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" @click="openVisorExamenesMuestra(muestra.muestra)"
                                  color="primary" icon>
                                  <v-icon size="18"> fas fa-eye </v-icon>
                                </v-btn>
                              </template>
                              <span>VER ESTUDIANTES</span>
                            </v-tooltip>

                            &nbsp;

                            <v-tooltip color="#1b1b1b" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" @click="
                                  verSomosHabiles(muestra)
                                  " icon color="warning">
                                  <v-icon size="18"> far fa-comment-dots </v-icon>
                                </v-btn>
                              </template>
                              <span>VER SOMOS HÁBILES</span>
                            </v-tooltip>

                          </td>
                          <td>
                            <v-chip class="ma-2" color="blue" text-color="white">
                              <v-avatar left class="blue darken-4">
                                {{ muestra.muestra.length - 1 }}
                              </v-avatar>
                              <strong> Estudiante(s)</strong>
                            </v-chip>
                          </td>
                          <!-- <td>{{ muestra.codigo }}</td> -->
                          <td>
                            <strong>
                              {{
                                tipo_contenido == 0 ? "Docente" : muestra.perfil
                              }}
                            </strong>
                          </td>
                          <td>
                            <v-chip class="ma-2" small :color="muestra.estado
                                ? 'green lighten-1'
                                : 'red lighten-1'
                              " text-color="white">
                              <strong>{{
                                muestra.estado ? "Activo" : "Inactivo"
                              }}</strong>
                            </v-chip>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <!-- PAGINACIÓN -->
                <v-col v-if="!readyloadLista" cols="12" sm="12">
                  <v-row class="pt-4">
                    <v-col cols="6" sm="2" md="2" lg="2"> </v-col>
                    <v-col cols="6" sm="5" md="5" lg="5"> </v-col>

                    <v-col class="d-flex justify-end" cols="12" sm="5" md="5" lg="5">
                      <v-pagination color="primary" v-model="paginaActual" :length="totalPaginas" total-visible="7"
                        next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="cambiarPagina"></v-pagination>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-row>
                <v-col cols="6">
                  <v-chip :label="true" :dark="true" color="warning">
                    <v-icon> mdi-account-multiple-outline </v-icon>
                    &nbsp;Lista de Estudiantes
                  </v-chip>
                </v-col>
                <v-col cols="6" align="end">
                  <div class="pb-4">
                    <v-btn class="btn_style3" dark @click="e1 = 1">VOLVER</v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-data-table :search="searchQtPreguntas" :headers="headersMuestraExamenes" :items="itemMuestraExamenes"
                fixed-header sort-by="unidad" class="elevation-1">
                <template v-slot:[`item.accion_opciones`]="{ item }">
                  <v-tooltip bottom color="dark">
                    <template v-slot:activator="{ on }">
                      <v-btn :disabled="item.estado ? true : false" @click="
                        verRespuestasResultados(
                          $event,
                          item.idexamen,
                          item.idusuario
                        )
                        " v-on="on" class="btn_ver px-0 mx-0" fab x-small>
                        <v-icon>fa fa-book</v-icon>
                      </v-btn>
                    </template>
                    <span>VER RESULTADOS</span>
                  </v-tooltip>
                </template>

                <!-- <template v-slot:[`item.codigo`]="{ item }">
                  <strong>{{ item.codigo }}</strong>
                </template> -->

                <template v-slot:[`item.idusuario`]="{ item }">
                  <strong style="color: orangered">{{
                    tipo_contenido == 0
                    ? item.usuarioexamen_model.persona.nombre_completo
                    : item.usuarioexamen.persona.nombre_completo
                  }}</strong>
                </template>

                <template v-slot:[`item.descripcion`]="{ item }">
                  <v-chip class="ma-2" small :color="item.autor == 'Docente'
                    ? 'green lighten-1'
                    : 'red lighten-1'
                    " text-color="white">
                    <strong>SOMOS HÁBILES</strong>
                  </v-chip>
                </template>

                <template v-slot:[`item.fecha_inicio`]="{ item }">
                  <strong> 📅 {{ item.fecha_inicio }}</strong>
                </template>

                <template v-slot:[`item.fecha_fin`]="{ item }">
                  <strong> 📅 {{ item.fecha_fin }}</strong>
                </template>
                🕓
                <template v-slot:[`item.estado`]="{ item }">
                  <i><strong :style="item.estado ? 'color:#9e9e9e' : 'color:red'">{{
                    item.estado ? "progreso ..." : "FINALIZADO !"
                  }}</strong></i>
                  <v-progress-linear :color="item.estado ? 'red lighten-1' : 'green darken-1'" rounded striped top
                    v-model="knowledge" height="15">
                    <strong>{{
                      !item.estado ? Math.ceil((knowledge = 100)) : 0
                    }}
                      %</strong>
                  </v-progress-linear>
                </template>
              </v-data-table>

              <!-- <v-btn color="primary" @click="e1 = 3"> Continue </v-btn>
  
              <v-btn text> Cancel </v-btn> -->
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>

              <v-btn color="primary" @click="e1 = 1"> Continue </v-btn>

              <v-btn text> Cancel </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </template>
    </ComunDialogComp>

    <!-- VISOR DE RESULTADOS -->
    <v-dialog v-model="dialogResultados" scrollable max-width="600px">
      <v-card>
        <v-card-title class="modal_title">
          <v-icon dark left>fas fa-layer-group</v-icon>
          Mis resultados
          <v-spacer></v-spacer>
          <v-tooltip bottom color="#1b1b1b">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab dark x-small class="btn_style4 mr-1" @click="verRptas = !verRptas">
                <v-icon>fa-eye</v-icon>
              </v-btn>
            </template>
            <span>{{ verRptas ? 'Ver mis respuestas' : 'Ver respuestas correctas' }}</span>
          </v-tooltip>
          <v-btn fab dark x-small class="btn_style3" @click="dialogResultados = false">
            <v-icon dark>fa-times</v-icon>
          </v-btn>
          <!-- NOTA: -->
          <!-- <v-chip
            class="ma-0"
            :color="
              resultadoVerExamen == 'APROBADO'
                ? 'green accent-4'
                : 'red accent-4'
            "
            text-color="white"
          >
            {{ resultadoVerExamen }}
          </v-chip> -->
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px">
          <br />
          <v-expansion-panels v-model="panels" multiple>
            <!-- <v-icon color="error"> mdi-alert-circle </v-icon> -->

            <v-expansion-panel v-for="(Misrespuestas, index) in misRespuestasResultados" :key="Misrespuestas.idpregunta">
              <v-expansion-panel-header disable-icon-rotate class="pb-0">
                <div>
                  <li style="margin-left: 15px" v-html="'<strong class=claseforzada>' +
                    (index + 1) +
                    ')</strong><br/>' +
                    Misrespuestas.pregunta
                    "></li>
                </div>
                <!-- <div :style="!Misrespuestas.valor_pregunta ? 'color:red;' : ''">
                  <li
                    style="margin-left: 15px"
                    v-html="
                      '<strong class=claseforzada>' +
                      (index + 1) +
                      ')</strong><br/>' +
                      Misrespuestas.pregunta
                    "
                  ></li>
                </div> -->
                <template v-slot:actions>
                  <v-icon v-if="!verRptas" right size="30" :color="Misrespuestas.valor_pregunta ? 'teal' : 'red'">
                    {{
                      Misrespuestas.valor_pregunta ? "fas fa-check " : "fas fa-times "
                    }}
                  </v-icon>
                  <v-icon v-else right size="30" color="teal">fas fa-check</v-icon>
                </template>
              </v-expansion-panel-header>
              <!-- ESTO COMENTADO ES EN EL CASO DE QUE DESEE IR A LA CLASE DE LA PREGUNTA INCORRECTA -->
              <!-- <div v-if="!Misrespuestas.valor_pregunta" class="d-flex pb-4 mx-10">
                <a style="color:red;" @click="verClase(Misrespuestas.idtema)" class="text-decoration-none"> <v-icon
                    color="error" small left>fas fa-book-open</v-icon>
                  <div style="font-weight:bold;display: inline;">Ir a repasar
                    unidad :</div> {{ Misrespuestas.nombre_clase }}
                </a>
              </div> -->
              <v-divider></v-divider>

              <v-expansion-panel-content>
                <v-list shaped>
                  <v-list-item-group color="primary" active-class="border-in">
                    <v-subheader class="d-flex justify-space-between">
                      <strong>
                        <v-icon>far fa-question-circle</v-icon>
                        {{ verRptas ? 'Respuestas correctas:' : 'Mis respuestas:' }}
                      </strong>
                      <small class="pa-5"> <i> {{
                        Misrespuestas.tipo_pregunta == 'res_mul'
                        ? 'Respuesta multiple'
                        : Misrespuestas.tipo_pregunta == 'res_uni'
                          ? 'Respuesta unica'
                          : 'Respuesta verdaderos - falso'
                      }} </i> </small>
                    </v-subheader>
                    <template v-if="verRptas">
                      <v-list-item v-for="nestedRespuestas in Misrespuestas.respuestas_marcadas"
                        :key="nestedRespuestas.idresdpuesta">
                        <v-list-item-icon>
                          <v-icon :color="nestedRespuestas.valor_respuesta ? 'green' : 'red'
                            " dark>{{
    nestedRespuestas.valor_respuesta
    ? "fas fa-check"
    : "fas fa-times"
  }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title>
                            <li v-html="nestedRespuestas.respuesta"></li>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-else>
                      <v-list-item v-for="nestedRespuestas in Misrespuestas.respuestas_marcadas"
                        :key="nestedRespuestas.idresdpuesta">
                        <v-list-item-icon>
                          <v-icon :color="nestedRespuestas.valor_respuesta_marcada ? 'green' : 'red'
                            " dark>{{
    nestedRespuestas.valor_respuesta_marcada
    ? "fas fa-check"
    : "fas fa-times"
  }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                          <v-list-item-title
                            :class="nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false && nestedRespuestas.valor_respuesta_marcada == true ? 'cruz' : ''">
                            {{ nestedRespuestas.respuesta }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-tooltip left color="error" v-if="(nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false &&
                            nestedRespuestas.valor_respuesta_marcada == true) || (nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
                              nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
                              'res_mul')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon color="error" dark v-bind="attrs" v-on="on">
                                <v-icon color="error">mdi-information</v-icon>
                              </v-btn>
                            </template>
                            <span> {{
                              nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false &&
                              nestedRespuestas.valor_respuesta_marcada == true
                              ? "Respuesta Incorrecta"
                              : nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
                                nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
                                'res_mul' ? "Faltó marcar esta respuesta" : ""
                            }}</span>
                          </v-tooltip>
                          <!-- <v-list-item-action-text>
                                <strong class="red--text"> {{
                                  nestedRespuestas.valor_respuesta == false && Misrespuestas.valor_pregunta == false &&
                                  nestedRespuestas.valor_respuesta_marcada == true
                                  ? "Respuesta Incorrecta"
                                  : nestedRespuestas.valor_respuesta == true && Misrespuestas.valor_pregunta == false &&
                                    nestedRespuestas.valor_respuesta_marcada == false && Misrespuestas.tipo_pregunta ==
                                    'res_mul' ? "Faltó marcar esta respuesta" : ""
                                }}</strong>
                              </v-list-item-action-text> -->
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <b>CALIFICACIÓN:</b>
          <v-chip class="ma-2" :color="resultadoVerExamen == 'APROBADO'
            ? 'green accent-4'
            : 'red accent-4'
            " text-color="white">
            <v-avatar left :class="resultadoVerExamen == 'APROBADO' ? 'green darken-4' : 'red'
              ">
              {{ notaPeru }}
            </v-avatar>
            {{ resultadoVerExamen }} ( <b> {{ notaPeru * 100 / 20 }}% </b> )
          </v-chip>
        </v-card-actions>
        <!-- <v-card-actions>
          <v-btn color="error" dark @click="dialogResultados = false">
            CERRAR
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text>
            Puntaje:
            <h1 class="ml-3 mb-1">{{ notaPeru + "%" }}</h1>
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <!-- LOADER INICIAR VISTA  -->
    <v-dialog v-model="loadingSpiner.estado" :width="loadingSpiner.ancho">
      <v-card :color="loadingSpiner.colorDialog" dark>
        <v-card-text class="pt-2 text-center">
          {{ loadingSpiner.titulo }}
          <v-progress-linear indeterminate :color="loadingSpiner.color" class="mb-0">
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { ProgramacionDocenteHeader } from "../../../helpers/headersTable.js";
import ModalCalendario from "./components/Calendario.vue";
import VisorContenido from "@/views/Manager/GestionContenido/viewGC/visorGestorContenido";
import ModalAsignarActividades from "./components/CalendarioActividades.vue";
import ModalVerActividades from "./components/ActividadesDocente.vue";
import ModalAsistenciaVirtual from "./components/AsistenciaVirtual.vue";
import ModalSeleccionarClase from "./components/SeleccionarClase.vue";
// import WizardProgClase from "./components/WizardProgClase/components/WizardProgClase";
import ParticipacionClase from "./components/ParticipacionClase.vue";
import CompetenciaComp from "./components/Competencias.vue";
import SesionAprendizaje from "@/views/Academico/ProgramacionDocente/sesionAprendizaje/sesionAprendizaje.vue";
import moment from "moment";
import AutocompleteComp from "../../../components/ComponentsEst/AutocompleteComp.vue";
import ComundataTablecomp from "../../../components/ComponentsEst/ComundataTablecomp.vue";
import ComunDialogComp from "../../../components/ComponentsEst/ComunDialogComp.vue";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
import visorSomosHabilesColegio from "../../GestorContenido/Colegio/creadorSomosHabiles/visorSomosHabiles.vue";
import visorSomosHabilesInteligenio from "../../Manager/GestionContenido/creadorSomosHabiles/visorSomosHabiles.vue";

export default {
  name: "programaciondocente",

  components: {
    visorSomosHabilesInteligenio,
    visorSomosHabilesColegio,
    ModalCalendario,
    VisorContenido,
    ModalAsignarActividades,
    ModalVerActividades,
    ModalAsistenciaVirtual,
    ModalSeleccionarClase,
    // WizardProgClase,
    CompetenciaComp,
    ParticipacionClase,
    SesionAprendizaje,
    AutocompleteComp,
    ComundataTablecomp,
    ComunDialogComp,
    ButtonComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 26, id_modulo: 7 }, //sud_modulo y modulo
    ProgramacionDocenteHeader,
    datoLogin: sessionStorage,
    ruta_api: API_URL, // ruta del servidor
    //URL_SPACE: BUCKET_ORIGIN_SPACE,
    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },

      hora: (value) => {
        if (value < "01:00") {
          return "El formato de la hora ingresada es incorrecto";
        } else {
          if (value >= "13:00") {
            return "El formato de la hora ingresada es incorrecto";
          }
        }
      },
    },
    // consulta principal
    test: false,
    datefiltros: false,
    menuStartData: false,
    menuEndData: false,
    start_date: null,
    end_date: null,
    allowedDaysR: [],

    // variable iniciales
    inhabilitarGradoDoc: true,
    inhabilitarAreaDoc: true,
    inhabilitarCursoDoc: true,

    filtroProgDoc: [],
    nivelDoc: [],
    gradoDocFilter: [],
    areaDocFilter: [],
    cursoDocFilter: [],
    cursoAdmDocFilterProgramarClase: "",

    gradoDoc: [],
    areaDoc: [],
    cursoDoc: [],

    showMenu: false,
    progDocente: [],

    progDocenteOriginal: [],
    search: "",
    horaActualizada: "01:01:00",
    ///////////////////////////////////////////////////////////////////////

    // componente Seleccionar Clase
    componenteSelecClase: "",
    estadoModalSelecClase: false,
    parametroSelecClase: [],
    estadoConsulta: false,
    ////////////////////////////////////

    // componente Wizard Programar Clase
    compNombre: null,
    compEstado: null,
    compTitle: null,
    compParametro: [],
    modal_wizard: false,
    ///////////////////////////////////

    // modal confirmacion
    dialog_delete: false,
    desc_delete: null,
    id_delete: null,
    /////////////////////////

    // componente del GC
    compName2: null,
    estadoComponente: false,
    parametroComp: {},

    //modal participacion
    componenteParticipacion: "",
    estado_modal_participacion: false,
    parametroParticipacionClase: [],

    // modal de seguimiento
    modal_seguimiento: false,
    seguimientoClase: [],
    ////////////////////////////////

    // modal visor de contenidos
    compName: "",
    estadoModalConfig: false,
    parametroConfigVisor: [],

    visor: false,
    api_list_contenidos: [],
    tipoVisor: "",
    ///////////////////////////

    // componente actividades del docente
    modal_calendarioActividad: false,
    compNombre2: null,
    compEstado2: null,
    compParametro2: [],

    tipoComponente: "",
    modalActividad: "",
    estadoModal: true,
    itemClaseSeccion: [],
    valorEvento: "",
    ///////////////////////////

    compNameVisorSH: null,
    estadoComponenteVisorSH: true,
    parametroCompVisorSH: [],

    // componente Asistencia Variables
    componenteAsistencia: "",
    estadoModalAsistencia: true,
    parametroAsistencia: [],
    ////////////////////////////

    // modal calendario
    componenteCalendario: "",
    estadoModalCalen: false,
    ////////////////////////////////////

    // modal sesion aprendizaje
    datosClaseActive: {},
    totalClases: 1,
    modalSesion: false,
    parametroSA: [],
    sesionAprendizaje: { id: null },
    loadingSesionAprendizaje: true,
    //VALIDAR RENDERING
    nombre: "",
    fecha: "",
    hora_inicio: "",

    // SOMOS HABILES PROG DOC
    verSomosHabilesPogDoc: false,
    itemArrayMuestras: [],
    // PROPIEDADES DE PAGINACION
    buscando: 0,
    paginaActual: 1,
    totalPaginas: 0,
    tamañoPorPagina: 6,
    tamañosPorPagina: [3, 6, 9],
    totalregistros: 0,
    MensajeNoExisteData: null,
    busquedaValor: "",
    orden: "idmuestra",
    titulosColumna: {
      opciones: false,
      codigo: false,
      descripcion: false,
      estado: false,
    },
    ascDescText: "DESC",
    cabecera: [
      {
        clase: "espetialclass text-left shrink-column",
        icono: "mdi-cog-outline",
        icono_accion: "mdi-cog-outline",
        valor: "OPCIONES",
        valor_accion: "idmuestra",
        exclusion: true,
      },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "Estudiantes",
        valor_accion: "idmuestra",
        exclusion: false,
      },
      // {
      //   clase: "text-left",
      //   icono: "mdi-chevron-double-down",
      //   icono_accion: "mdi-chevron-double-up",
      //   valor: "CÓDIGO",
      //   valor_accion: "codigo",
      //   exclusion: false,
      // },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "AUTOR",
        valor_accion: "perfil",
        exclusion: false,
      },
      {
        clase: "text-left",
        icono: "mdi-chevron-double-down",
        icono_accion: "mdi-chevron-double-up",
        valor: "ESTADO",
        valor_accion: "estado",
        exclusion: false,
      },
    ],
    // SKELETON
    readyloadLista: true,
    e1: 1,
    searchQtPreguntas: null,
    headersMuestraExamenes: [
      {
        text: "RESULTADOS",
        value: "accion_opciones",
        class: "secondary black--text",
      },
      // { text: "CÓDIGO", value: "codigo", class: "secondary black--text" },
      {
        text: "ESTUDIANTE",
        value: "idusuario",
        class: "secondary black--text",
      },
      {
        text: "TIPO EXAMEN",
        value: "descripcion",
        class: "secondary black--text",
      },
      {
        text: "INICIO",
        value: "fecha_inicio",
        class: "secondary black--text",
      },
      {
        text: "FIN",
        value: "fecha_fin",
        class: "secondary black--text",
      },
      {
        text: "ESTADO",
        value: "estado",
        sortable: false,
        class: "secondary black--text shrink-column_estado",
      },
    ],
    itemMuestraExamenes: [],
    knowledge: 0,
    verRptas: false,
    panels: [0, 1, 2, 3, 4],
    dialogResultados: false,
    notaPeru: null,
    resultadoVerExamen: null,
    misRespuestasResultados: [],
    tipo_contenido: null,
    //generar excel
    data1:{},
    btnReasigar: false,

    idprog_doc:null,

    editOptions:{}

  }),

  computed: {
    ...mapState(["loadingSpiner"]),
    ...mapState(["diasEscolaresColegio"]),
    ...mapGetters("login", ["componenteEvento"]),

    nombre_clase() {
      return this.$route.params.value;
    },
  },
  mounted() {
    this.$store.commit("mostrarLoading", {
      titulo: "Cargando clases",
      color: "#fff",
      colorDialog: "#212121",
      ancho: 300,
    });
    this.loadMain();
    this.$store.dispatch("getAlldiasEscolares").then(() => {
      this.allowedDaysR = this.diasEscolaresColegio;
    });
  },

  created() {
    this.initValueRouter();
    this.actualizarParamentro();
  },

  methods: {

    //////////FUNCIÓN PARA FORMATEAR LAS HORA EN AM Y PM /////////////////////////////////////
    formatearHora(hora) {
      return moment(hora, "HH:mm:ss").format("hh:mm A");
    },

    //////////FUNCIÓN PARA FORMATEAR LAS FECHA DIA MES AÑO /////////////////////////////////////
    formatearFecha(fecha) {
      return moment(fecha).format("DD/MM/YY");
    },

    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    //Programador JAAC
    initValueRouter() {
      this.search = this.nombre_clase;
    },

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ////////////////////////////////////////////////////////

    //// modal calendario
    ...mapMutations("progDocente", ["setActivarCalendario"]),

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();
      this.horaActualizada = "00:00:00";
      try {
        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/progDocente/getQuery${params}`,
          {
            params: {
              fecha_inicio: this.start_date,
              fecha_final: this.end_date,
            },
          }
        );
        let data = response.data;

        this.nivelDoc = data.payload.NivelDoc;
        this.gradoDoc = data.payload.GradoDoc;
        this.areaDoc = data.payload.AreaDoc;
        this.cursoDoc = data.payload.CursoDoc;
        this.seccionDoc = data.payload.SeccionDoc;
        this.progDocente = data.payload.ProgDocente;
        this.progOriginal = data.payload.ProgDocente;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      } finally {
        NProgress.done();
        this.$store.commit("ocultarLoading");
      }
    },

    limpiarFecha(string) {
      if (string == "inicio") {
        this.start_date = null;
      } else {
        this.end_date = null;
      }

      this.loadMain();
    },


    async reasignarSomosHabiles(idprog_doc){

      // REACTUALIZAR CLASE EJECUTADA
      try {
        
        let response = await axios.put(`/academico/progDocente/changeStateProg/${idprog_doc}`);

        this.verSomosHabilesPogDoc = false;

        this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });

      } catch (error) {
        console.log(error);
      }

    },

    CloseverSomosHabilesPogDoc() {
      this.verSomosHabilesPogDoc = false;
      this.itemArrayMuestras = [];
      this.itemMuestraExamenes = [];
    },

    // validarEnlace(enlaceVirtual, fechaClase, horaInicio, horaFin, estado) {
    // Original comentado, comentado por no usarse
    validarEnlace(enlaceVirtual, fechaClase, horaInicio, horaFin) {
      var mensaje = "";
      var error = 0;
      /////// FUNCION PARA TRAER FECHA ACTUAL
      function ckeckTime(i) {
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      }

      let fechaActual = moment().format("YYYY-MM-DD");

      if (fechaActual > fechaClase) {
        mensaje = "La Clase ya culminó";
        error = 1;
      } else if (fechaActual < fechaClase) {
        mensaje = "La Clase no ha iniciado";
        error = 1;
      } else {
        let hora = new Date();
        let horaHora = ckeckTime(hora.getHours());
        let horaMin = ckeckTime(hora.getMinutes());
        let horaActual = `${horaHora}:${horaMin}:00`;

        if (horaActual < horaInicio) {
          mensaje += "La Clase no ha iniciado";
          error = 1;
        }

        if (horaActual > horaFin) {
          mensaje += "La Clase ya culminó";
          error = 1;
        }
      }

      if (error == 0) {
        //this.setEnviarMens({tipo:"S", mensaje: `Activar Link`, tiempo:null})
        window.open(enlaceVirtual);
      } else {
        this.setEnviarMens({ tipo: "E", mensaje: `${mensaje}`, tiempo: null });
      }
    },

    //  manejador del evento nivel de la programacion de clase
    eventNivelDoc() {
      this.inhabilitarGradoDoc = false;
      this.inhabilitarAreaDoc = true;
      this.inhabilitarCursoDoc = true;

      // filtro y cargo los valores del grado segun el nivel
      //let filtro = this.asociarCl.id_nivel

      this.gradoDocFilter = this.gradoDoc.filter(
        (el) => el.id_nivel == this.filtroProgDoc.id_nivel
      );

      //CARGAMOS LA PROGRAMACION EN BASE AL NIVEL
      this.progDocente = this.progOriginal.filter(
        (el) => el.id_nivel == this.filtroProgDoc.id_nivel
      );
    },

    // manejador del evento grado de la programacion de clase
    eventGradoDoc() {
      this.inhabilitarAreaDoc = false;
      this.inhabilitarCursoDoc = true;
      this.areaDocFilter = this.areaDoc.filter(
        (el) => el.id_grado == this.filtroProgDoc.id_grado
      );

      this.seccionDocFilter = this.seccionDoc.filter(
        (el) => el.id_grado == this.filtroProgDoc.id_grado
      );

      this.progDocente = this.progOriginal.filter(
        (el) =>
          el.id_nivel == this.filtroProgDoc.id_nivel &&
          el.id_grado == this.filtroProgDoc.id_grado
      );
    },

    // manejador del evento area de programacion de clase
    eventAreaDoc() {
      this.inhabilitarCursoDoc = false;
      // filtro y cargo los valores del los curso segun el grado
      let gradoDocFilter = this.cursoDoc.filter(
        (el) => el.id_grado == this.filtroProgDoc.id_grado
      );
      this.cursoDocFilter = gradoDocFilter.filter(
        (el) => el.id_area == this.filtroProgDoc.id_area
      );

      this.progDocente = this.progOriginal.filter(
        (el) =>
          el.id_nivel == this.filtroProgDoc.id_nivel &&
          el.id_grado == this.filtroProgDoc.id_grado &&
          el.id_area == this.filtroProgDoc.id_area
      );
    },

    eventCursoDoc() {
      this.progDocente = this.progOriginal.filter(
        (el) =>
          el.id_nivel == this.filtroProgDoc.id_nivel &&
          el.id_grado == this.filtroProgDoc.id_grado &&
          el.id_area == this.filtroProgDoc.id_area &&
          el.id_curso == this.filtroProgDoc.id_curso
      );
    },

    // RUTA LARGA PARA PROGRAMAR UNA CLASE CON SU SESION DE APRENDIZAJE
    asociarClase() {

      this.parametroSelecClase = {
        items: null,
        evento: "agregar",
        nivelDoc: this.nivelDoc,
        gradoDoc: this.gradoDoc,
        areaDoc: this.areaDoc,
        cursoDoc: this.cursoDoc,
        seccionDoc: this.seccionDoc
      };

      this.componenteSelecClase = "ModalSeleccionarClase"; //VISTA SELECCIONAR CLASE
      this.estadoModalSelecClase = true;
    
    },

      // Levanta la modal para programar la clase  (agregar)
      editItem(items) {
      this.parametroSelecClase = {
        items,
        evento: "editar",
        nivelDoc: this.nivelDoc,
        gradoDoc: this.gradoDoc,
        areaDoc: this.areaDoc,
        cursoDoc: this.cursoDoc,
        seccionDoc: this.seccionDoc,
      };

      this.componenteSelecClase = "ModalSeleccionarClase"; //VISTA SELECCIONAR CLASE
      this.estadoModalSelecClase = true;

    },

    async recibirAdmCursoHijo(id) {
      //Variable que se captura desde SeleccionarClase (Indispensable)
      this.cursoAdmDocFilterProgramarClase = id;
    },


    //-- fn creada para pasarle como parametro a :allowed-dates
    allowedDays: function (date) {
      return this.allowedDaysR.includes(date);
    },

    // recargar loadMain al programar clase
    cargarMain() {
       this.editOptions = {};
       this.loadMain();
      //  this.estadoConsulta = true;        
    },

    async verSeguimiento(id) {
      this.modal_seguimiento = true;

      let response = await axios.get(
        "/academico/progDocente/getSeguimiento/" + id
      );
      this.seguimientoClase = response.data.payload.Seguimiento;
    },

    // componente de  calendario
    verCalendario() {
      this.componenteCalendario = "ModalCalendario";
      this.estadoModalCalen = true;
    },

    // activa la modal para confirmar el borrar el registro
    deleteConfirm(items) {
      this.dialog_delete = true;
      this.id_delete = items.id;
      (this.nombre = items.nombre_tema),
        (this.fecha = items.fecha),
        (this.hora = items.hora_inicio);
      // ]`Tema: ${items.nombre_tema}, fecha:${items.fecha},Hora ${items.hora_inicio} - (${items.id})`
    },

    //------------BORRAR Registro -------------
    async deleteItem() {
      this.dialog_delete = false;
      try {
        let resp = await axios.delete(
          "/academico/progDocente/" + this.id_delete
        );
        this.loadMain();
        this.dialog = false;
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // botos para visualizar clases de la programacion de contenido
    visualizarClase(id_clase, tipo_contenido) {
      // tipo_contenido es igual 0 se muestra el contenido del colegio
      // si tipo contenido es igual a 1 se muestra el contenido en manager
      // al funal el contenido se de esta funciono se trae en base a la clase
      // pero así la programaron

      let datosVGC = Object.assign({
        evento: "view",
        id_clase,
        miniatura: false,
        id_diapositiva: 1,
        tipo_contenido: tipo_contenido == 1 ? "manager" : "colegio",
      });

      this.compName2 = "VisorContenido";
      this.estadoComponente = true;
      this.parametroComp = datosVGC;
    },

    // funcion para cerrar modal
    cerrarVisor() {
      this.visor = false;
      this.api_list_contenidos = [];
      this.tipoVisor = "";
    },

    abrirParticipacionClase() {
      this.estado_modal_participacion = true;
      this.componenteParticipacion = "ParticipacionClase";
    },

    cerrarParticipacionClase() {
      this.estado_modal_participacion = false;
      this.componenteParticipacion = "";
    },

    visualizarCompetencia(id, id_colegio) {
      this.compNombre = "CompetenciaComp";
      this.compEstado = true;

      this.compParametro = {
        id,
        id_colegio,
        evento: "visualizar",
      };
    },
    // botos para visualizar calendario de actividades por seccion para crear la actividad
    async asignarActividades(item) {
     
      this.modal_calendarioActividad = true;
      this.compNombre2 = "ModalAsignarActividades";
      this.compEstado2 = true;
      this.compParametro2 = { item, evento: "agregar" };
    },

    //mddal ver actividades del docente
    verActividades() {
      this.tipoComponente = "ModalVerActividades";
      this.estadoModal = true;
    },

    // function para visualizar la clase virtual de la programacion docente
    async asistenciaVirtual(item) {
      this.componenteAsistencia = "ModalAsistenciaVirtual";
      this.estadoModalAsistencia = true;
      this.parametroAsistencia = item;
    },

    async GenerarDocumentoSa(id_sa) {
      try {
        const params = {
          id_colegio: this.datoLogin.id_colegio,
        };

        let api_sa = `/academico/sesionAprendizajeProg/${id_sa}/documento/`;
        let res = await axios.post(api_sa, params, { responseType: "blob" });
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `sesion_aprendizaje_${id_sa}.pdf`);
        fileLink.setAttribute("target", "_blank");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al generar el documento`,
          tiempo: null,
        });
      }
    },

    // eslint-disable-next-line no-unused-vars
    async GetSesionAprendizaje(item, id) {

      var params = {
        id_clase: item.id_clase,
        evento: "view",
        totalTemas: this.progDocente.length,
        item,
      };

      try {
        let resp = await axios.get(
          `/academico/sesionAprendizajeProg/existeSA/${item.id_clase}/`
        );

        if (item.tipo_contenido == 1) {
          let response = await axios.get(
            `/manager/sesionAprendizaje/clase/${item.id_clase}/`
          );
          params.item.id_sa = response.data.id;
        }

        if (item.tipo_contenido == 0) {
          let resp = await axios.get(
            `/academico/sesionAprendizaje/clase/${item.id_clase}/`
          );
          params.item.id_sa = resp.data.id;
        }

        if (resp.data == 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No exite sesión de aprendizaje cargada",
            tiempo: null,
          });
          return;
        }

        // this.modalSesion = true;
        // this.parametroSA = params;

        this.parametroSelecClase = {
          items:item,      
          evento: "ver",
          nivelDoc: this.nivelDoc,
          gradoDoc: this.gradoDoc,
          areaDoc: this.areaDoc,
          cursoDoc: this.cursoDoc,
          seccionDoc: this.seccionDoc
        };

        this.componenteSelecClase = "ModalSeleccionarClase"; //VISTA SELECCIONAR CLASE
        this.estadoModalSelecClase = true;

      } catch (error) {
        console.log(error);
      }
    },

    /*------------------------*/
    /* MÉTODO ORDEN x COLUMNA */
    /*------------------------*/
    ordenPorColumna(tituloColumna) {
      const me = this;
      me.orden = tituloColumna;
      Object.keys(me.titulosColumna).forEach((item) => {
        if (item === tituloColumna) {
          me.titulosColumna[tituloColumna] = !me.titulosColumna[tituloColumna];
          me.ascDescText = me.titulosColumna[tituloColumna] ? "ASC" : "DESC";
        } else {
          me.titulosColumna[item] = false;
        }
      });
      me.listarMuestra();
    },

    /*----------------------------*/
    /* MÉTODO OBETENER PARAMETROS */
    /*----------------------------*/
    obtenerParametros(
      valorBusqueda,
      paginaActual,
      tamañoPorPagina,
      orden,
      titulosColumna,
      idusuario,
      perfil
    ) {
      const parametros = {};
      if (valorBusqueda) {
        parametros.valor = valorBusqueda;
      }
      if (paginaActual) {
        parametros.paginaActual = paginaActual - 1;
      }
      if (tamañoPorPagina) {
        parametros.tamañoPorPagina = tamañoPorPagina;
      }
      if (orden) {
        parametros.orden = orden;
      }
      if (titulosColumna) {
        parametros.titulosColumna = titulosColumna;
      }
      if (idusuario) {
        parametros.idusuario = idusuario;
      }
      if (perfil) {
        parametros.perfil = perfil;
      }
      return parametros;
    },

    /*------------------------*/
    /* MÉTODO CAMBIAR PAGINAS */
    /*------------------------*/
    cambiarPagina(numeroPagina) {
      const me = this;
      me.buscando = 0;
      me.paginaActual = numeroPagina;
      me.listarMuestra();
    },

    /*-----------------------------*/
    /* MÉTODO REGISTROS POR PAGINA */
    /*-----------------------------*/
    cambiarCantidadPaginas(tamaño) {
      const me = this;
      me.buscando = 0;
      me.tamañoPorPagina = tamaño;
      me.paginaActual = 1;
      me.listarMuestra();
    },

    /*----------------------*/
    /* MÉTODO SOMOS HABILES */
    /*----------------------*/
    visualizarSomosHabilesProgDoc(id_clase, id_colegio, tipo_contenido,dataProgDoc) {

      this.datosClaseActive = dataProgDoc; 

      const me = this;
      me.e1 = 1;
      me.verSomosHabilesPogDoc = true;
      me.listarMuestraSomosHabiles(id_clase, tipo_contenido,dataProgDoc.id);
    },

    async openVisorExamenesMuestra(examenes) {
      const me = this;
      me.e1 = 2;
      me.itemMuestraExamenes = examenes.filter(
        (el) => el.autor.toLowerCase() == "estudiante"
      );
    },

    /** 
     _____________________________________________
    |          MÉTODO VER SOMOS HABILES         */
    verSomosHabiles(item) {

      // me.VerlistaSomosHabiles = false;
      this.parametroCompVisorSH = {
        event: "view_somosHabiles",
        items: item,
      };

      this.compNameVisorSH = item.tipo_contenido == 1 ? "visorSomosHabilesInteligenio" : "visorSomosHabilesColegio";
      this.estadoComponenteVisorSH = true;

    },
    /** 
     _________________________________
    |          MÉTODO CLOSE         */
    closeModalVisorSH() {
      // this.VerlistaSomosHabiles = true;
      this.estadoComponenteVisorSH = false;
    },

    async verRespuestasResultados(event, idexamen, idusuario) {
      const me = this;
      let URI;
      if (this.tipo_contenido == 0) {
        URI = `/simulador/simuladorExamenColegio/simuladorAdmDetalles/simuladorAdmDE/listarAdmPdetalleResultados/${idusuario}/lista/${idexamen}`;
      } else {
        URI = `/simulador/simuladorExamen/simuladorDetalles/simuladorDE/listarPdetalleResultados/${idusuario}/lista/${idexamen}`;
      }
      try {
        const response = await axios.get(URI);

        const datosRespuestas = response.data.map((number) => {
          return {
            idtema: number.idtema,
            nombre_clase: number.nombre_clase,
            idexamen: number.idexamen,
            idpregunta: number.idpregunta,
            pregunta: number.pregunta,
            tipo_pregunta: number.tipo_pregunta,
            valor_pregunta: number.valor_pregunta,
            respuestas: number.respuestas,
            respuestas_marcadas: number.respuestas_marcadas,
          };
        });

        me.misRespuestasResultados = datosRespuestas;

        let buenas = 0;
        let totalRptas = 0;
        datosRespuestas.forEach((element) => {
          totalRptas++;
          if (element.valor_pregunta) {
            buenas++;
          }
        });

        let result = (buenas * 100) / totalRptas;
        let resultNotaPeru = (result * 20) / 100;
        // me.notaPeru = Math.round(result);
        me.notaPeru = Math.round(resultNotaPeru);
        if (result >= 60) {
          me.resultadoVerExamen = "APROBADO";
        } else {
          me.resultadoVerExamen = "DESAPROBADO";
        }

        me.dialogResultados = true;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    async listarMuestraSomosHabiles(idclase, tipo_contenido, idprog_doc) {

      this.idprog_doc = idprog_doc;

      const me = this;
      this.tipo_contenido = tipo_contenido;
      let URI;
      if (tipo_contenido == 0) {
        URI =
          "/simulador/simuladorExamenColegio/simuladorAdmMuestras/simuladorAdmM/listarAdmMuestrasSomosHabilesPaginacion/";
      } else {
        URI =
          "/simulador/simuladorExamen/simuladorMuestras/simuladorM/listarMuestrasSomosHabilesPaginacion/";
      }

      me.readyloadLista = true;
      const patrametosListar = me.obtenerParametros(
        me.busquedaValor,
        me.paginaActual,
        me.tamañoPorPagina,
        me.orden,
        me.ascDescText,
        me.datoLogin.id,
        me.detallePerfil
      );

      try {
        const response = await axios.get(URI + idclase, {
          params: patrametosListar,
        });

        const { filas, totalPaginas, totalFilas } = response.data;

        if (response.data.message != null) {
          me.MensajeNoExisteData = response.data.message;
        } else {

          if (filas[0].muestra.length - 1 == 0) {
            this.btnReasigar = true;
          }else{
            this.btnReasigar = false;
          }

          me.itemArrayMuestras = filas;
          me.totalPaginas = totalPaginas;
          me.totalregistros = totalFilas;
          me.MensajeNoExisteData = null;
        }
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      } finally {
        me.readyloadLista = false;
      }
    },

    resetearFiltros() {
      this.filtroProgDoc = [];
      this.nivelDoc = [];
      this.gradoDoc = [];
      this.areaDoc = [];
      this.cursoDoc = [];
      this.seccionDoc = [];
      this.progDocente = [];
      this.progOriginal = [];
      this.start_date = null;
      this.end_date = null;
      this.loadMain();
    },

    

    async generarExcel(){
       try {
        
        let archivoADescargar = "";
        this.data1 = {
          anioLectivo: parseInt(this.datoLogin.id_ano_lectivo),
          colegio: parseInt(this.datoLogin.id_colegio),
          id_persona: parseInt(this.datoLogin.id_persona),
          codigoReporte: "horario_docente",
          tamanioPorHoja: 50,
          BUCKET_ORIGIN_SPACE: this.URL_SPACE
        }
    
        let response = await axios.post(
          'academico/progDocente/excelhorariodocente',
            this.data1
        );
        
        let dataResponse = response.data;
   
        this.setEnviarMens({
          tipo: dataResponse.messageT,
          mensaje: dataResponse.message,
          tiempo: 3000,
        });
        this.generandoReporte = 0;
        if (dataResponse.messageT == "S") {
          archivoADescargar = dataResponse.fileToDownload;
          axios({
            url:
              "/reporte/formatoReporte/bajarReporte/" + dataResponse.nameReport,
            method: "GET",
            responseType: "blob", // important
          }).then((response) => {
            this.setEnviarMens({
              tipo: "S",
              mensaje: "¡Descargando reporte!",
              tiempo: 3000,
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", archivoADescargar);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          });
        }
       }catch(error){
        console.log(error)
       }
    }
  },
};
</script>
<style>
strong.claseforzada {
  position: absolute;
  top: 33px;
  left: 15px;
}

.shrink-column {
  width: 25%;
  white-space: nowrap;
}

.shrink-column_estado {
  width: 25%;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .v-simple-table {
    overflow-x: auto;
  }
}

.cruz {
  position: absolute;
  text-decoration: none;
  width: 72%;
}

.cruz::before,
.cruz::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #ff000061;
  top: 40%;
  bottom: 0%;
  /* transform: rotate(-30deg); */
  left: 0;
}

/* left: 0; */
.v-list-item__title.cruz {
  padding: 5px;
}
</style>
